import { Component, computed, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { TextComponent, UserLogoComponent } from '@camelot/ui';
import { fullName } from '@camelot/utils';

import { CommunicationParticipant, CommunicationParticipantExtended } from '../../services/dto/communication';

@Component({
  selector: 'cam-communication-participant',
  templateUrl: './participant.component.html',
  styleUrls: ['./participant.component.scss'],
  imports: [TextComponent, TranslatePipe, UserLogoComponent],
})
export class ParticipantComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  participant = input.required<CommunicationParticipant>();

  readonly conversationParticipant = computed(() => this._matchedParticipant() ?? this._clientFallback());

  readonly email = computed(() => {
    const client = this._clientFallback();
    return this.participant().email || client?.email || client?.contact?.mail || '';
  });

  readonly fullName = fullName;

  private readonly _matchedParticipant = computed(() => {
    const participant = this.participant();
    return (
      this.conversationParticipants().find(p => {
        if (participant.userId && p.userId === participant.userId) {
          return true;
        }
        if (participant.contactId && p.contactId === participant.contactId) {
          return true;
        }
        return false;
      }) ?? null
    );
  });

  // Message chat écrit depuis le portail : seul le userId du compte portail est renseigné, et ce compte
  // n'est pas un participant de la conversation. On affiche alors le contact client de la conversation.
  private readonly _clientFallback = computed(() => {
    const participant = this.participant();
    if (this._matchedParticipant() || !participant.userId || participant.contactId || participant.email) {
      return null;
    }
    return this.conversationParticipants().find(p => p.isClient) ?? null;
  });
}
